import React, { useState, useEffect } from "react";
import { logo } from "../assets/svg/svg";
import web3Config from '../web3/web3Config.json'; // Importing contract JSON file
import hostContract from '../web3/hostContract.json'; // Importing contract JSON file
import { transactionAction } from "../helper/chain-helper";
import { contractCall, getPublicKeyValue, web3AccountCheck } from "../helper/web3helper";
import Cookies from "universal-cookie";
import { deleteContacts, deleteDatabase } from "../db/db-helper";
import { clearContactsDekCache } from "../helper/contactsDek";
import { clearDekCache } from "../helper/dekManager";
import { clearEnvelopeKeyCache } from "../helper/envelopeV3";
import { checkAdminEmails, createWeb2User } from "../service/api-actions"
import { CompleteLoader } from '../modals/common-alert'
// import { log } from "../service/api-actions.js";
import { getBrowserDetails } from '../helper/userActivity.js';
import { buildLoginProof } from "../auth/loginProof.js";
import { login } from "../service/api-actions";
import { getAssetWalletAddress } from "../helper/wallet-helper.js";
import { toast, Bounce } from 'react-toastify';
import { validateCoupon } from "../service/api-actions";
import { useNavigate } from 'react-router-dom';
import { reportError, toErrorString } from "../utils/errorLogger.js";

// const web3 = new Web3(web3Config?.CHAIN_DETAILS?.rpcUrls[0]);
// const hostContractMethods = new web3.eth.Contract(hostContract.contract, web3Config.CONTRACT);
const cookies = new Cookies();

const Signup = () => {
    const [text, setText] = useState("")
    const [nameTaken, setNameTaken] = useState(null);
    const [accountAddress, setAccount] = useState('');
    const [userName, setUserName] = useState('');
    const [loader, setLoader] = useState(false);
    const [couponCode, setCouponCode] = useState('');
    const [couponValid, setCouponValid] = useState(false);
    const [couponStatus, setCouponStatus] = useState(null);
    const [couponChecking, setCouponChecking] = useState(false);
    const [showCoupon, setShowCoupon] = useState(false);
    const [couponDetails, setCouponDetails] = useState(null);
    const history = useNavigate();

    const hostContractMethods = contractCall(hostContract.contract, web3Config.CONTRACT);

    useEffect(() => {
        getAccount();
    }, []);

    const getAccount = async () => {
        try {
            setLoader(true)
            await new Promise((resolve) => setTimeout(resolve, 1000));
            if (!window.ncogProvider) {
                history('/'); // Redirect to home if provider is not available
                return;
            }
            //get the wallet address from local storage
            const walletAddress = localStorage.getItem("walletAddress");
            if (walletAddress) {
                setAccount(walletAddress);
            } else {
                await new Promise((resolve) => setTimeout(resolve, 1000));
                if (!window.ncogProvider) {
                    history('/'); // Redirect to home if provider is not available
                    return;
                }
                const accounts = await window.ncogProvider.request({ method: "ncog_accounts" });
                if (accounts?.selectedAccount?.accountAddress) {
                    setAccount(accounts?.selectedAccount?.accountAddress);
                    localStorage.setItem("walletAddress", accounts?.selectedAccount?.accountAddress);
                } else {
                    history('/'); // Redirect to home if no account found
                }
            }
        } catch (err) {
            console.error("Error fetching account:", err);
            const errorStr = toErrorString(err || err.message);
            const userName = localStorage.getItem('UserName');
            reportError({
                endpoint: '-',
                message: `FileName: Signup.js, Fun: getAccount, ${String(err.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            history('/'); // Redirect to home on error
        } finally {
            setLoader(false)
        }
    }

    // Returns true = available, false = taken/invalid/error, 'short' = coupon flow decides.
    async function checkAvailability(name) {
        if (!/^[a-zA-Z0-9._]+$/.test(name)) {
            setNameTaken("Sorry, only letters (a-z), numbers (0-9), and periods (. and _) are allowed.");
            return false;
        }
        if (name.length < 5 && !couponValid) {
            setNameTaken("Username must be at least 5 characters long.");
            return 'short';
        }
        try {
            setNameTaken(null);
            const response = await checkAdminEmails(name);
            if (response?.exists) {
                setNameTaken('Username Is not Available');
                return false;
              }
            const value = await hostContractMethods.methods.getPublicKeyOfUser(name + "@" + web3Config.DOMAIN).call();
            const result = !!value === true ? 'Username Is not Available' : false;
            setNameTaken(result);
            return !value;
        } catch (err) {
            setNameTaken(err.error);
            console.error("Error checking availability:", err);
            const errorStr = toErrorString(err || err.message);
            const userName = localStorage.getItem('UserName');
            reportError({
                endpoint: '-',
                message: `FileName: Signup.js, Fun: checkAvailability, ${String(err.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
            setNameTaken("Something went wrong. Please try again.");
            return false;
        }
    }

    async function applyCoupon() {
        if (!couponCode?.trim()) {
            setCouponStatus('Please enter a coupon code.');
            setCouponValid(false);
            return false;
        }
        try {
            setCouponChecking(true);
            setCouponStatus(null);
            const resp = await validateCoupon(couponCode.trim());
            const isValid = resp?.statusCode === 200;
            if (isValid) {
                setCouponValid(true);
                setCouponStatus('Coupon applied! You can use a shorter username.');
                setNameTaken(null);
                setCouponDetails(resp?.data);
                // re-validate username if present
                // if (userName) {
                //     await checkAvailability(userName);
                // }
                return true;
            } else {
                setCouponValid(false);
                setCouponStatus('Invalid or expired coupon.');
            }
        } catch (e) {
            console.error(e);
            const errorStr = toErrorString(e || e.message);
            const userName = localStorage.getItem('UserName');
            reportError({
                endpoint: '/dsuite/validateCoupon',
                message: String(e.message || 'Unhandled error'),
                error: errorStr,
                userName: userName || '',
                level: 'warn',
            });
            setCouponValid(false);
            setCouponStatus('Failed to validate coupon. Please try again.');
            return false;
        } finally {
            setCouponChecking(false);
        }
    }

    async function removeCoupon() {
        setCouponValid(false);
        setCouponStatus(null);
        setShowCoupon(false);
        setCouponDetails(null);
        if (userName) {
            if (userName.length < 5) {
                setNameTaken("Username must be at least 5 characters long.");
            } else {
                await checkAvailability(userName);
            }
        }
    }

    async function confirmUsername(name) {
        const availability = await checkAvailability(name)
        try {
            if (!name) return null;
            // Taken/invalid name: the nameTaken message is on screen — do NOT fire a
            // transaction the contract will revert (the wallet fails it silently).
            if (availability === false) {
                toast.error(nameTaken || 'Username is not available — if it is yours, go back and sign in.', {
                    position: "top-center",
                    transition: Bounce,
                });
                return;
            }
            if (userName.length < 5) {
                const couponApplied = await applyCoupon();
                if (!couponApplied) {
                    return;
                }
            }
            setLoader(true);
            setText("Please wait while we securely store your data on the blockchain, This will be faster next time.")
            const publicKey = await getPublicKeyValue();
            if (!publicKey) {
                setLoader(false);
                setText("")
                return null;
            }
            if (!accountAddress) {
                setLoader(false);
                setText("")
                return null;
            }
            // Record the wallet's ASSET (ML-DSA) address as an on-chain attribute. This is what login
            // proof-of-possession binds the challenge signature to: without it the account can never sign
            // in — here or in any other DSuite app. It CANNOT go in the _walletAddress parameter, which
            // must stay `accountAddress` (the ML-KEM data address every app looks accounts up by).
            const assetAddress = await getAssetWalletAddress();
            if (!assetAddress) {
                setLoader(false);
                setText("");
                toast.error("Could not read your wallet's asset address. Please reconnect your NCOG wallet and try again.", {
                    position: "top-center",
                    transition: Bounce,
                });
                return null;
            }
            const attributes = [["assetAddress", assetAddress]];
            const functionParams = ["", "", name + "@" + web3Config.DOMAIN, web3Config.DOMAIN, name, publicKey, accountAddress, true, attributes];
            let hash = await transactionAction(hostContractMethods, "createAccount", functionParams, accountAddress, 'hostContract');

            // The NCOG wallet returns no usable tx hash ({response:{txHash:{}}}), so a null
            // here may still be a successful send. The chain is the source of truth: poll for
            // the account before declaring failure.
            if (!hash) {
                for (let i = 0; i < 15 && !hash; i++) {
                    await new Promise((resolve) => setTimeout(resolve, 2000));
                    const created = await hostContractMethods.methods
                        .getPublicKeyOfUser(name + "@" + web3Config.DOMAIN).call()
                        .catch(() => null);
                    if (created) hash = "confirmed-on-chain";
                }
            }
            if (!hash) {
                toast.error("Account creation did not reach the blockchain. Check your wallet and try again.", {
                    position: "top-center",
                    transition: Bounce,
                });
            }

            if (hash) {
                const userObject = { name: name + "@" + web3Config.DOMAIN, wallet: accountAddress, publicKey: publicKey };
                // The account was just created WITH its assetAddress attribute, so proof-of-possession can
                // bind immediately — this first login is signed like every other one. The proof failure is
                // reshaped into login()'s own failure shape so the branches below stay the single place
                // sign-in problems are reported; letting it throw would instead land in the outer catch,
                // which reports a *signup* error for an account that in fact already exists on-chain.
                let getToken;
                try {
                    const { signature, signerPublicKey } = await buildLoginProof(name + "@" + web3Config.DOMAIN, publicKey);
                    getToken = await login(name + "@" + web3Config.DOMAIN, publicKey, couponDetails?.coupon?.coupon_code, signature, signerPublicKey);
                } catch (proofError) {
                    getToken = { isAuth: false, isAccess: false, message: proofError.message };
                }
                if (getToken && getToken.isAuth && getToken.token) {
                    // Everything already in localStorage belongs to whoever used this browser before, so it
                    // goes before this account's session is written. Signup used to write on top of it, and
                    // the leftover 'UserName' is the one dekManager.currentUser() reads — so creating a
                    // second account in a browser that had signed in before resolved the PREVIOUS account's
                    // DEK for the whole session. Only walletAddress is put back (routes/SignIn.js clears the
                    // same way): it identifies the connected wallet, not an account, and requireAuth() reads
                    // it on the very next route.
                    localStorage.clear();
                    localStorage.setItem("walletAddress", accountAddress);
                    cookies.set("userObject", userObject, { path: "/" });
                    cookies.set("accessToken", getToken.token, { path: "/" });
                    localStorage.setItem("accessToken", getToken.token);
                    // Same key and same JSON shape routes/SignIn.js, routes/WalletConnect.js and
                    // components/Profile.js all write. Signup was the only sign-in site that skipped it, so a
                    // browser whose last identity change was a signup has no record for the wallet-reconnect
                    // path (WalletConnect.js reads localStorage "userObject") to work from.
                    localStorage.setItem("userObject", JSON.stringify(userObject));
                    // Signup never wrote this, so every brand-new account ran its entire first session with
                    // no DEK at all: getSessionDEK() throws 'no userName available' without it, which kills
                    // attachment sends, the Sent-folder copy, drafts and every mail-cache write until the
                    // user happens to come back through the account chooser. Same key and same shape as
                    // routes/SignIn.js — the full user@domain identity, not the bare label.
                    localStorage.setItem("UserName", userObject.name);
                    // A brand-new account: any cache present belongs to someone else, so this wipe stays —
                    // together with the in-memory DEKs, which would otherwise be the previous account's.
                    clearDekCache();
                    clearContactsDekCache();
                    // And the v3 per-message content keys, which belong to whoever was signed in before.
                    clearEnvelopeKeyCache();
                    await deleteDatabase();
                    // deleteDatabase() only drops 'web3Dmails'. The contacts cache lives in a SEPARATE
                    // 'Dcontact' DB, its rows are keyed by the constants "contactList"/"DecryptedValue" with
                    // no owner tag, and they hold the DECRYPTED contact list — so creating a second account
                    // in a browser that had signed in before left the previous account's contacts readable
                    // by, and merged into, the new one. Same wipe routes/SignIn.js and
                    // routes/WalletConnect.js run on an identity change; a signup is always one.
                    await deleteContacts();
                    await createWeb2User(name + "@" + web3Config.DOMAIN);
                    await getBrowserDetails();
                    // await log(await getBrowserDetails(), 'signUp');
                    window.open(`/app/inbox`, "_self");
                } else if (!getToken?.isAccess && !getToken.isAuth) {
                    toast.error(getToken?.message, {
                        position: "top-center",
                        transition: Bounce,
                        autoClose: 5000,
                    });
                    window.open('/app', '_self');
                } else {
                    window.open('/app/signup', '_self');
                }
            }
            setLoader(false);
            setText("")
            return true;
        } catch (err) {
            setLoader(false);
            setText("")
            console.error(err);
            const errorStr = toErrorString(err || err.message);
            const userName = localStorage.getItem('UserName');
            reportError({
                endpoint: '-',
                message: `FileName: Signup.js, Fun: getAccount, ${String(err.message || 'Unhandled error')}`,
                error: errorStr,
                userName: userName || '',
            });
        }
    }

    return (

        <div className='parent-no-layout-container'>
            <div className='sign-up-container'>
                <div className='header-signup-value'>
                    <h4>  Choose Your Unique Username </h4>
                    <span> Choose your unique username, this name will work as your dmail account as well as your Web3ID!</span>
                </div>

                <div className='input-values-sign-up-parent'>
                    <div className={nameTaken === false ? 'input-values-sign-up available' : "input-values-sign-up"} id="signupInput">
                        <div className="input-field-div">
                            <input type="text" id="username" placeholder="Username" onChange={(event) => {
                                let value = event?.target?.value?.trim()?.toLowerCase();
                                document.getElementById("username").value = value;
                                setNameTaken(null);
                                setUserName(value)
                            }} />
                            <span className="domain-input-default"> @{web3Config.DOMAIN} </span>
                            {nameTaken === false && logo.tick_svg}
                            {(nameTaken || nameTaken === null) && logo.check_svg}
                        </div>
                    </div>


                    {/* Coupon toggle / input */}
                    {!couponValid && !showCoupon && (
                        <div className='coupon-apply-toggle'>
                            <button
                                onClick={() => setShowCoupon(true)}
                                className='coupon-toggle-btn'
                            >
                                Have a code?
                            </button>
                        </div>
                    )}

                    {!couponValid && showCoupon && (
                        <div className='coupon-input-container'>
                            <input
                                type="text"
                                placeholder="Enter coupon code"
                                value={couponCode}
                                onChange={(e) => {
                                    setCouponCode(e.target.value);
                                    setCouponStatus(null);
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' && !couponChecking && couponCode?.trim()) {
                                        applyCoupon();
                                    }
                                }}
                                className='coupon-input'
                            />
                            <button
                                className='coupon-apply-btn'
                                onClick={applyCoupon}
                                disabled={couponChecking || !couponCode?.trim()}
                            >
                                {couponChecking ? 'Applying...' : 'Apply'}
                            </button>
                            <button
                                className='coupon-cancel-btn'
                                onClick={() => { setShowCoupon(false); setCouponCode(''); setCouponDetails(null); setCouponStatus(null); setCouponValid(false); }}
                            >
                                Cancel
                            </button>
                        </div>
                    )}

                    {nameTaken &&
                        <div className="error-response-success error" >
                            {logo.warning_svg}
                            <span> {nameTaken} </span>
                        </div>
                    }

                    {nameTaken === false &&
                        <div className="error-response-success success" >
                            {logo.tick_svg}
                            <span> Username is Available </span>
                        </div>
                    }

                    {couponStatus && !couponValid &&
                        <div className="error-response-success error">
                            {logo.warning_svg}
                            <span> {couponStatus} </span>
                        </div>
                    }


                    {couponValid && (
                        <div className="error-response-success success">
                            {logo.tick_svg}
                            <span>
                                Coupon applied{couponCode ? `: ${couponCode}` : ''}. Usernames under 5 characters allowed
                                <button
                                    onClick={removeCoupon}
                                    style={{
                                        marginLeft: 8,
                                        background: 'transparent',
                                        border: 'none',
                                        color: '#ef4444',
                                        cursor: 'pointer',
                                        textDecoration: 'underline'
                                    }}
                                >
                                    Remove
                                </button>
                            </span>
                        </div>
                    )}

                </div>


                <div className="btn-confirm-sign">

                    {(nameTaken || nameTaken === null) &&
                        <button className={(userName && !nameTaken) ? "confirm-btn-sign name-input-class" : "confirm-btn-sign"} onClick={() => { checkAvailability(userName) }} id="confirmsignin"> Confirm </button>
                    }

                    {nameTaken === false &&
                        <button className="confirm-btn-sign confirm-class" onClick={() => { confirmUsername(userName) }} id="confirmsignin"> Confirm "{userName}@{web3Config.DOMAIN}" </button>
                    }
                </div>

                {/* <button className='faucet-button mt-4' onClick={() => {
                    window.open(faucetLink, "_blank");
                }}><span>Get Free Test Tokens?<br />
                        (NEC Faucet)</span></button> */}
            </div>
            <CompleteLoader isOpen={loader} text={text} />
        </div>
    )
}

export default Signup
